import type { FunctionComponent } from 'react';

import { BINARY_DECOMPOSITION } from '../../../../../shared/featureFlags/flagNames';
import { BannerAttention, BannerStyle } from '../../../../../typings/enums';
import { useLocation, useRouter } from '../../../../contexts/RouterContext';
import { useIsFeatureEnabled } from '../../../../helpers/features/featureFlags';
import Banner from '../../../generic/Banner';
import Button from '../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button/button-constants';
import useRevision from '../../hooks/useRevision';

/**
 * This component is used to display a banner when the revision has partial results.
 */
const PartialResultBanner: FunctionComponent = () => {
  const isBinaryDecompositionEnabled = useIsFeatureEnabled(BINARY_DECOMPOSITION);
  const revision = useRevision();
  const { pathname } = useLocation();
  const { push } = useRouter();

  if (
    !revision.data?.dependency_count ||
    revision.data.dependency_count <= 0 ||
    revision.isSteady ||
    !isBinaryDecompositionEnabled
  ) {
    return null;
  }

  return (
    <Banner
      title="Partial results ready"
      body="You can view them now or wait until the full analysis is complete."
      actions={
        <Button
          onClick={() => {
            push(`${pathname}/browse/dependencies`);
          }}
          type={BUTTON_TYPE.SECONDARY}
          size={BUTTON_SIZE.SMALL}
        >
          View partial results
        </Button>
      }
      bannerStyle={BannerStyle.Success}
      bannerAttention={BannerAttention.Low}
    />
  );
};

export default PartialResultBanner;
